import { Drawer } from "@mui/material";
import { useIntl } from "react-intl";

type Props = {
  travellersSelected: number;
  travellersToSelect: number;
};

export function TravellerSelectionStatusDrawer({
  travellersSelected,
  travellersToSelect,
}: Props) {
  const intl = useIntl();

  return (
    <Drawer
      anchor="bottom"
      variant="persistent"
      open
      sx={{
        "& .MuiDrawer-paper": {
          textAlign: "center",
          border: "none",
          paddingTop: "calc(var(--spacing) * 2)",
          paddingBottom: "calc(var(--drawer-height, 0) + var(--spacing) * 2)",
          backgroundColor:
            travellersSelected === travellersToSelect
              ? "var(--color-surface-accent-soft)"
              : "var(--color-surface-neutral-medium)",
          fontSize: "var(--text-sm)",
          color: "var(--color-text-primary)",
        },
      }}
    >
      {intl.formatMessage(
        {
          defaultMessage: "{selectedCount} of {totalCount} selected",
          description: "travellers.selectedOfX",
        },
        {
          selectedCount: travellersSelected,
          totalCount: travellersToSelect,
        },
      )}
    </Drawer>
  );
}
